import useDataLoader from '~/hooks/shared/useDataLoader';
import {get_check_in_stats} from '~/api/zero-api';


export default function useCheckInStatsLoader() {
    return useDataLoader(get_check_in_stats);
}